<template>
  <v-layout row wrap>
    <v-flex xs12 sm10 md6 offset-md3 offset-sm1>
      <cliente-cotizacion v-if="!hascotizacion"></cliente-cotizacion>
      <v-card v-else-if="hascotizacion" class="factura" @keyup.ctrl.80 = "impresion">
        <v-card-title class="primary">
          <div style="display: flex; justify-content: space-between; margin: 0; width: 100%;" class="encabezado">
            <v-flex xs12  sm6>
              <b1 style="padding: 0" class="white--text"  name="cliente"> Cliente: {{cliente.cliente}}</b1>
            </v-flex>
          </div>
          <div class="factura__date">
            <v-flex xs12 >
              <b1 style="padding: 0" class="white--text"> Fecha: {{fecha}}</b1>
            </v-flex>
          </div>
          <!--
          <v-flex sm3 xs6 class="hidden-sm-and-down pa-0 ma-0">
            <v-checkbox v-model="escambio" label="cambiar producto" dark>
            </v-checkbox>
          </v-flex>
          !-->
          <v-flex xs6 class="pa-0 ma-0 total"><h5 class="white--text">Total: Q.{{total}}</h5></v-flex>
          <h4 class="warning--text existencia"> Existencia: {{producto.existencia}}</h4>
           <v-flex>
           <v-btn fab dark small primary v-on:click.native="dialog = true" v-if="haslineas" class="print">
              <v-icon dark>print</v-icon>
            </v-btn>
             <v-btn fab dark small  v-if="haslineas" class="print yellow darken-4" @click="guardarcotizacion">
              <v-icon dark>save</v-icon>
            </v-btn>
            <v-btn fab dark small primary v-on:click.native="dialogbusqueda = true" @click="focusbusqueda()" class="print"  v-bind:disabled="validatefactura">
              <v-icon dark>search</v-icon>
            </v-btn>
             <v-btn fab dark small accent v-on:click.native="message = true">
              <v-icon dark>email</v-icon>
            </v-btn>
        </v-flex>
        </v-card-title>
        <v-flex sm12>
            <v-alert  error value="false" v-if="error">
              {{message_error}}
            </v-alert>
          </v-flex>
        <v-layout class="buscador ma-0 pa-0" fluid wrap >
          <v-flex xs12 sm2 >
            <v-text-field
              id="search"
              ref = "search"
              @keyup.ctrl.80 = "impresion"
              @keyup.enter="searchproducto"
              singleLine
              label="cod.Producto"
              v-model="producto.barra"
              v-bind:disabled="validatefactura"
              autofocus='true'

            >
            </v-text-field>
          </v-flex>

          <v-flex xs12 sm2 >
            <v-text-field
              singleLine
              label="precio"
              autofocus
              disabled
              v-model="precio"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 sm3>
            <v-text-field
              singleLine=""
              label="producto"
              disabled
              v-model="producto.producto"
            >
            </v-text-field>
          </v-flex>
          <v-flex  xs4 sm1>
            <v-text-field
              type="number"
              @change="checklista()"
              @keyup.enter="guardarventa"
              singleLine
              label="cantidad"
              v-model="cantidad"
              ref="cantidad"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs4 sm2>
            <div class="select">
               <select v-model="presentacion"  @change="checklista">
                <option v-for="press in presentaciones" v-bind:value="press">
                  {{ press.presentacion }}
                </option>
            </select>
            </div>
          </v-flex>
          <v-flex xs4 sm2>
            <div class="select xs6">
               <select v-model="listado"  @change="checklista">
                <option v-for="lista in producto.listaprecios" v-bind:value="lista">
                  {{ lista.lista.nombre }}
                </option>
            </select>
            </div>
          </v-flex>
          <v-flex hidden-md-and-up class="justify-center" xs12>
            <v-btn fab dark small class="print blue darken-4" @click="guardarventa">
              <v-icon dark>save</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card v-show="hascotizacion" class="factura__detalle">

        <v-flex style="overflow-x: auto" class="tabla">
           <table class="table text-md-center">
             <tr>
               <th></th>
              <th v-for="header in headers"> {{header.text}}</th>
             </tr>
              <tbody>
                <tr v-for="linea in lineas">
                  <td>
                  <v-btn icon class="red--text text--darken-2" @click="eliminar(linea)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  </td>
                  <td>{{linea.cantidad}}</td>
                  <td>{{linea.presentacion }}</td>
                  <td>{{linea.producto_name}}</td>
                  <td>{{linea.precio }}</td>
                  <td>{{linea.precio * linea.cantidad | currency('Q') }}</td>
                </tr>
                <tr class="factura__detalle__total">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Total</td>
                  <td>{{total}}</td>
                </tr>
              </tbody>
           </table>
        </v-flex>

      </v-card>
      <v-dialog v-model="dialog" lazy absolute persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Imprimir Cotización</div>
        </v-card-title>
        <v-card-text>
          <v-alert  error value="false" v-if="error">
           {{message_error}}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialog = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="imprimircotizacion">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogbusqueda" lazy absolute persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Buscar Producto</div>
           <v-flex sm12>
             <v-text-field label="Nombre" v-model="nombreproducto" @keyup="searchproductos" autofocus ref="searchprodi">
          </v-text-field>
           </v-flex>
        </v-card-title>
        <v-card-text>
          <ul class="listadoproducto">

            <li v-for="product, key in this.productos"
                @click="searchproductodialog(product), dialogbusqueda=false, nombreproducto = ''"
                @keyup.enter="searchproductodialog(product), dialogbusqueda=false, nombreproducto = ''"
                v-bind:tabindex="0">
               {{product.producto}}
            </li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-bind:tabindex="-1" class="green--text darken-1" flat="flat" @click.native="dialogbusqueda = false" @click="resetbusqueda">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <div class="enletras" style="width: 100%">
        <span>TOTAL EN LETRAS: {{numerosaletras}}</span>
      </div>
      <v-flex class="firmas">
        <v-flex sm6>Cliente</v-flex>
      </v-flex>

    </v-flex>
  </v-layout>
</template>

<script>
  import Ccliente from './Ccliente.vue'
  import NumerosLetras from '../librerias/numerosaletras'
  export default {
    components: {'cliente-cotizacion': Ccliente},
    created: function () {
      this.href.search.focus()
    },
    data () {
      return {
        cantidad: 1,
        iscredito: false,
        prueba: true,
        foco: false,
        nombreproducto: '',
        dialogbusqueda: false,
        escambio: false,
        efectivo: '',
        message: false,
        headers: [
          { text: 'Cantidad' },
          { text: ' Presentación' },
          { text: 'Descripción' },
          { text: 'Precio' },
          { text: 'Subtotal' }
        ]
      }
    },
    methods: {
      impresion () {
        this.dialog = true
      },
      searchproducto () {
        this.$store.dispatch('buscarproducto', { producto: this.producto.barra, bodega: 1 })
        this.$refs.cantidad.focus()
      },
      searchproductodialog (event) {
        if (event.barra) {
          this.$store.dispatch('buscarproducto', {producto: event.barra, bodega: 1})
        } else {
          this.$store.dispatch('buscarproducto', {producto: event.codigo, bodega: 1})
        }
        this.$refs.cantidad.focus()
      },
      searchproductos () {
        this.$store.dispatch('buscarproductos', {producto: this.nombreproducto, bodega: 1})
      },
      checklista () {
        if (this.listado.lista.nombre.toLowerCase() !== 'l4' && this.listado.lista.nombre.toLowerCase() !== 'l5' && this.producto.listaprecios.length <= 2) {
          let listadoordenado = this.producto.listaprecios.sort((dato1, dato2) => {
            return dato1.minimo - dato2.minimo
          })
          let listas = []
          let lista = []
          listadoordenado.map((dato) => {
            if (dato.lista.nombre.toLowerCase() !== 'l4' &&
              dato.lista.nombre.toLowerCase() !== 'l5' && dato.minimo <=
              this.cantidad * (this.presentacion.unidades)) {
              listas.push(dato)
            }
          })
          if (listas.length > 0) {
            lista = listas.reverse()
            this.$store.commit('updateselect', lista[0])
          } else {
            listas = listadoordenado.map(dato => {
              if (dato.lista.nombre.toLowerCase() !== 'l4' && dato.lista.nombre.toLowerCase() !== 'l5') {
                lista.push(dato)
              }
            })
            this.$store.commit('updateselect', lista[0])
          }
        }
      },
      guardarventa () {
        this.$store.dispatch('insertarlineacotizacion', { producto: this.producto.id,
          cotizacion: this.cliente.id,
          precio: this.precio,
          cantidad: this.cantidad,
          presentacion: this.presentacion.presentacion,
          lista: this.listado.id,
          subtotal: this.cantidad * this.precio
        })
        this.$refs.search.focus()
      },
      cambiarcomentario () {
        this.$store.dispatch('actualizarcomentario', {factura: this.factura})
      },
      eliminar (linea) {
        this.$store.dispatch('eliminarlineacotizacion', linea)
      },
      guardarcotizacion () {
        this.$store.dispatch('guardarcotizacion', {factura: this.factura})
      },
      imprimircotizacion () {
        this.$store.dispatch('imprimircotizacion', {cotizacion: this.cliente})
      },
      resetbusqueda () {
        this.nombreproducto = ''
        this.$store.commit('actualizarproductos', [])
      },
      focusbusqueda () {
        let vm = this
        setTimeout(function () {
          vm.$refs.searchprodi.focus()
        }, 100)
      }
    },
    computed: {
      productos: function () {
        return this.$store.getters.productos
      },
      haslineas: function () {
        if (this.lineas.length > 0) {
          return true
        } else {
          return false
        }
      },
      hascotizacion: function () {
        return this.$store.getters.hascotizacion
      },
      lineas: function () {
        return this.$store.getters.lineascotizacion
      },
      total: function () {
        let temptotal = 0
        this.lineas.map(dato => {
          temptotal += dato.cantidad * dato.precio
        })
        return (temptotal).toFixed(2) || 0
      },
      cliente: function () {
        return this.$store.getters.clientescotizacion
      },
      producto: function () {
        return this.$store.getters.producto
      },
      fecha: function () {
        let fecha = new Date(this.$store.getters.clientescotizacion.fecha)
        return fecha.toLocaleDateString('es-gt')
      },
      listado: {
        get: function () {
          return this.$store.getters.listado || ''
        },
        set: function (dato) {
          this.$store.commit('updateselect', dato)
        }
      },
      dialog: {
        get: function () {
          return this.$store.getters.dialogo
        },
        set: function (dato) {
          this.$store.commit('actualizardialog', dato)
        }
      },
      precio: function () {
        let porcentaje = this.listado.porcentaje / 100
        if (this.presentacion.presentacion === 'unidad') {
          return (this.producto.preciounidad * porcentaje + this.producto.preciounidad * 1).toFixed(2)
        }
        if (this.presentacion.presentacion !== 'unidad' && (this.listado.lista.nombre !== 'l6' || this.listado.lista.nombre !== 'l7')) {
          console.log('se ejecuto')
          return (this.presentacion.unidades * this.producto.precio_costo * this.listado.porcentaje / 100 + this.producto.precio_costo * this.presentacion.unidades).toFixed(2)
        }
        return (this.producto.preciounidad * porcentaje + this.producto.preciounidad * 1).toFixed(2) * this.presentacion.unidades
      },
      presentaciones: function () {
        return this.$store.getters.presentaciones
      },
      presentacion: {
        get: function () {
          return this.$store.getters.presentacion
        },
        set: function (dato) { this.$store.commit('actualizarpresentacion', dato) }
      },
      error: function () {
        return this.$store.getters.error_numero
      },
      cambio: function () {
        return (this.total - this.efectivo).toFixed(2)
      },
      message_error: function () {
        return this.$store.getters.message_error
      },
      numerosaletras: function () {
        return NumerosLetras.NumeroALetras(this.total, {
          plural: 'QUETZALES',
          singular: 'QUETZAL',
          centPlural: 'CENTAVOS',
          centSingular: 'CENTAVOS'
        })
      },
      validatefactura: function () {
        if (this.lineas.length === 13) {
          return true
        }
        return false
      }
    }
  }
</script>
<style>
   @media only screen and (min-device-width: 480px){
     .existencia {
       position: fixed;
       top: 13em;
     }
     .existencia{
       position: fixed;
       left: 10em;
       top: 6.1em;
     }
     .listadoproducto li {
       padding: 8px;
     }
   }
</style>



// WEBPACK FOOTER //
// Cotizacionadd.vue?fcd7b81a